import React from 'react';
import { Colors, Media } from '@/styles';
import { IconProps } from './Icon';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const Community = ({ color, size, ...props }: IconProps): JSX.Element => {
  return (
    <StyledSvg
      size={size}
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5206 0C5.14611 0 0.789062 4.328 0.789062 9.66667C0.789062 21.6667 16.8964 24 16.8964 24V19.3333H17.9032C23.2777 19.3333 27.6347 15.0053 27.6347 9.66667C27.6347 4.328 23.2777 0 17.9032 0H10.5206ZM14.2119 11.6667C14.6569 11.6667 15.0836 11.4911 15.3983 11.1785C15.713 10.866 15.8897 10.442 15.8897 10C15.8897 9.55797 15.713 9.13405 15.3983 8.82149C15.0836 8.50893 14.6569 8.33333 14.2119 8.33333C13.7669 8.33333 13.3401 8.50893 13.0255 8.82149C12.7108 9.13405 12.534 9.55797 12.534 10C12.534 10.442 12.7108 10.866 13.0255 11.1785C13.3401 11.4911 13.7669 11.6667 14.2119 11.6667ZM21.2589 10C21.2589 10.442 21.0821 10.866 20.7674 11.1785C20.4528 11.4911 20.026 11.6667 19.581 11.6667C19.136 11.6667 18.7092 11.4911 18.3946 11.1785C18.0799 10.866 17.9032 10.442 17.9032 10C17.9032 9.55797 18.0799 9.13405 18.3946 8.82149C18.7092 8.50893 19.136 8.33333 19.581 8.33333C20.026 8.33333 20.4528 8.50893 20.7674 8.82149C21.0821 9.13405 21.2589 9.55797 21.2589 10ZM8.84275 11.6667C9.28775 11.6667 9.71452 11.4911 10.0292 11.1785C10.3438 10.866 10.5206 10.442 10.5206 10C10.5206 9.55797 10.3438 9.13405 10.0292 8.82149C9.71452 8.50893 9.28775 8.33333 8.84275 8.33333C8.39776 8.33333 7.97099 8.50893 7.65633 8.82149C7.34167 9.13405 7.1649 9.55797 7.1649 10C7.1649 10.442 7.34167 10.866 7.65633 11.1785C7.97099 11.4911 8.39776 11.6667 8.84275 11.6667Z"
        fill={color}
      />
    </StyledSvg>
  );
};

Community.defaultProps = {
  color: Colors.pointLight,
};

const StyledSvg = styled.svg<IconProps>`
  ${({ size }) => {
    if (size) {
      return `
        width: ${size}px;
        height: auto;
      `;
    } else {
      return css`
        @media ${Media.sm} {
          width: 20px;
          height: 18px;
        }
        @media ${Media.md} {
          width: 27px;
          height: 24px;
        }
        @media ${Media.lg} {
          width: 27px;
          height: 24px;
        }
      `;
    }
  }}
`;

export default Community;
